export default __webpack_public_path__ + "static/media/naidi-4-1.b64fdcff.svg";